
/**
 * Defines importance badges with consistent value and label properties
 * to ensure filtering works correctly
 */
export const getImportanceBadges = () => {
  return {
    1: { value: 1, label: "Very Low" },
    2: { value: 2, label: "Low" },
    3: { value: 3, label: "Medium" },
    4: { value: 4, label: "High" },
    5: { value: 5, label: "Critical" }
  };
};

export default getImportanceBadges;
